<div class="event-overview">
	<div class="event-overview__view-toggle">
		<b-tabs vertical class="has-background-white" type="is-toggle" v-model="activeView">
			<b-tab-item icon="list" label="Liste"></b-tab-item>
			<b-tab-item icon="timeline" label="Timeline"></b-tab-item>
		</b-tabs>
	</div>

	<div v-show="activeView === 0" class="event-overview__list">
		<slot></slot>
	</div>

	<event-timeline v-if="activeView === 1 && hasTimelineData"
		:shows="timelineData.shows"
		:is-closest-show-before-today="timelineData.isClosestShowBeforeToday">
	</event-timeline>
</div>
